// extracted by mini-css-extract-plugin
export default {"white":"#fff","notificationRed":"#ff4c68","primaryIcon":"#309df0","ColorVariants":"bbh_a bho_i bho_j","ColorVariants__color":"bbh_b bho_rp","ColorVariants__more":"bbh_c bho_vv"};